<template>
  <div class="section">
    <div class="container">
      <!-- Page Header -->
      <div class="mb-md">
        <div class="columns is-vcentered">
          <div class="column is-one-third">
            <breadcrumbs :history="[{ label: 'Settings', name: 'settings'}]" current="Retailer Onboarding Notes" />
          </div>
          <div class="column is-one-third">
            <h1 class="has-text-centered is-size-4">Retailer Onboarding Notes</h1>
          </div>
        </div>
      </div>
      <div class="pb-lg mb-lg">
        <RetailerNotesList />
      </div>
    </div>
  </div>
</template>

<script>
import RetailerNotesList from '../components/Assistant/RetailerNotesList'
export default {
  components: {
    RetailerNotesList
  }
}
</script>
